/* eslint-disable */
// Chakra Imports
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import NavbarLinksUser from './NavbarLinksUser';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Portal,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { matchPath, useLocation } from 'react-router-dom';
import _, { toUpper } from 'lodash';
export default function UserNavbar(props: {
  fixed: boolean;
  // secondary: boolean;
  brandText: string;
  onOpen: (...args: any[]) => any;
}) {
  const [scrolled, setScrolled] = useState(false);

  const isPath = (path: string) => {
    let match = matchPath(window.location.pathname, {
      path: path,
      exact: true,
      strict: false,
    });

    return match ? true : false;
  };

  const isShowBreadcrumb = () => {
    return (
      isPath('/user/group/:groupId/question/:questionId') ||
      isPath('/user/group/:groupId') ||
      isPath('/user/room')
    );
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNavbar);

    return () => {
      window.removeEventListener('scroll', changeNavbar);
    };
  });

  // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
  let navbarPosition = 'fixed' as const;
  let navbarFilter = 'none';
  let navbarBackdrop = 'blur(20px)';
  let navbarShadow = 'none';
  let navbarBg = useColorModeValue(
    'rgba(244, 247, 254, 0.2)',
    'rgba(11,20,55,0.5)'
  );
  let navbarBorder = 'transparent';
  let secondaryMargin = '0px';
  let paddingX = '15px';
  let gap = '0px';
  let secondaryText = useColorModeValue('gray.700', 'white');

  const location = useLocation();
  const pathname = _.split(location?.pathname, '/user/');
  const breadCrumbName = _.replace(pathname?.[1], '-', ' ');
  const { brandText } = props;
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  return (
    <Box
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      backgroundPosition="center"
      backgroundSize="cover"
      borderRadius="16px"
      borderWidth="1.5px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ xl: 'center' }}
      display={'flex'}
      minH="75px"
      justifyContent={{ xl: 'center' }}
      lineHeight="25.6px"
      mx="auto"
      mt={secondaryMargin}
      pb="8px"
      right={{ base: '12px', md: '30px', lg: '30px', xl: '30px' }}
      px={{
        sm: paddingX,
        md: '10px',
      }}
      ps={{
        xl: '12px',
      }}
      pt="8px"
      top={{ base: '12px', md: '16px', xl: '18px' }}
      w={'100vw'}
    >
      <Flex
        w="100%"
        flexDirection={{
          sm: 'column',
          md: 'row',
        }}
        alignItems={{ xl: 'center' }}
        mb={gap}
      >
        {!isShowBreadcrumb() && (
          <Flex mb={{ sm: '8px', md: '0px' }} align="center" justify="center">
            <Breadcrumb ml={{ md: '50px', xl: '65px' }}>
              <BreadcrumbItem color={secondaryText} fontSize="sm" mb="5px">
                <BreadcrumbLink href="/user" color={secondaryText} pt="5px">
                  Trang chủ
                </BreadcrumbLink>
              </BreadcrumbItem>
              {breadCrumbName.length > 0 ? (
                <BreadcrumbItem color={secondaryText} fontSize="sm">
                  <BreadcrumbLink
                    href={location?.pathname}
                    color={secondaryText}
                  >
                    {/* {breadCrumbName?.toUpperCase()} */}
                    {brandText}
                  </BreadcrumbLink>
                </BreadcrumbItem>
              ) : (
                <React.Fragment />
              )}
            </Breadcrumb>
          </Flex>
        )}
        <Box ms="auto" w={{ sm: '100%', md: 'unset' }}>
          <NavbarLinksUser secondary={true} />
        </Box>
      </Flex>
    </Box>
  );
}
